import React from 'react';
import 'components/DogAvatar/DogAvatar.css';
import Image from 'components/Image';

function DogAvatar({ avatarUri, onClick, className }) {
    console.log(avatarUri)
    return (
        <div onClick={onClick} className={`dog-avatar ${className}`} data-aos="zoom-in">
            <div className={'dog-avatar-container shadow blur'}>
                <Image className={'dog-avatar-image'} alt={'dog'} src={avatarUri} />
            </div>
        </div>
    );
}

export default DogAvatar;
